import { render } from "./TransferDialog.vue?vue&type=template&id=000d5e41"
import script from "./TransferDialog.vue?vue&type=script&lang=js"
export * from "./TransferDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__